import request from '@/utils/request'

// 查询列表
export function apiScpMrpPlansPlanVersionList (query) {
  return request({
    url: '/scp/scpMrpPlans/planVersionList',
    method: 'get',
    params: query
  })
}

// 日志详情
export function apiScpMrpPlanLogsDetails (query) {
  return request({
    url: '/scp/scpMrpPlanLogs/details',
    method: 'get',
    params: query
  })
}

// 日志列表
export function apiScpMrpPlanStagesPlanRunFrame (query) {
  return request({
    url: '/scp/scpMrpPlanStages/planRunFrame',
    method: 'get',
    params: query
  })
}

// 获取计划版本
export function apiScpMrpPlansLatestVersion (query) {
  return request({
    url: '/scp/scpMrpPlans/latestVersion',
    method: 'get',
    params: query
  })
}
